<i18n>
{
"en": {
  "WELCOME": "Welcome back, friend",
  "SELECTSCHOOL": "Select School",
  "USERNAME": "Username",
  "PASSWORD": "Password",
  "AUTHENTICATING": "Authenticating...",
  "LOGIN": "Login",
  "FORGOTPASSWORD": "Forgot password?",
  "DEFAULT": "default",
  "PLEASEENTERYOUREMAILADDRESS": "Please enter your email address",
  "FORGOTPASSWORDT": "Forgot Password",
  "SUBMIT": "Submit",
  "CANCEL": "Cancel",
  "INVALIDEMAILADDRESS": "Invalid Email Address",
  "USEREMAILADDRESSNOTINTHESYSTEM": "User email address not in the system",
  "ANEMAILHASBEENSENT": "An email has been sent.",
  "SUCCESS": "Success",
  "INVALIDUSER": "Invalid user",
  "SENDING": "Sending...",
  "ISREQUIRED": "is required.",
  "MUSTCONTAINAVALIDEMAILADDRESS": "must contain a valid email address.",
  "LOADING": "Loading..."
},
"ar": {
  "WELCOME": "مرحبا بك مرة أخرى، صديق",
  "SELECTSCHOOL": "حدد المدرسة",
  "USERNAME": "اسم المستخدم",
  "PASSWORD": "كلمه السر",
  "AUTHENTICATING": "...مصادقة ",
  "LOGIN": "تسجيل الدخول",
  "FORGOTPASSWORD": "هل نسيت كلمة المرور؟",
  "DEFAULT": "الافتراضي",
  "PLEASEENTERYOUREMAILADDRESS": "الرجاء إدخال عنوان البريد الإلكتروني الخاص بك",
  "FORGOTPASSWORDT": "هل نسيت كلمة المرور",
  "SUBMIT": "قدم",
  "CANCEL": "إلغاء",
  "INVALIDEMAILADDRESS": "عنوان البريد الإلكتروني غير صالح",
  "USEREMAILADDRESSNOTINTHESYSTEM": "عنوان البريد الإلكتروني للمستخدم ليس في النظام",
  "ANEMAILHASBEENSENT": ".تم ارسال البريد الإلكتروني",
  "SUCCESS": "نجاح",
  "INVALIDUSER": "المستخدم غير صالح",
  "SENDING": "...إرسال",
  "ISREQUIRED": ".مطلوب",
  "MUSTCONTAINAVALIDEMAILADDRESS": ".يجب أن يحتوي على عنوان بريد إلكتروني صالح",
  "LOADING": "جار التحميل..."
}
}
</i18n>
<template>
    <div  class="form-signin">
        <div align="center">
          <div class="img" v-loading="loading_logo" :element-loading-text="$t('LOADING')" :style="{backgroundImage: 'url(' + loadingLogo() + ')'}"></div>
        </div>
        <div align="center">
        <h2>{{lang=='en' ? main_school.Name_EN :  main_school.Name_AR }}</h2>
    </div>
    <el-form  ref="mainForm" :model="user" label-width="120px" label-position="top">
        <el-row v-if="show_dropdown" id="school">
          <el-form-item :label="$t('SELECTSCHOOL')" prop="school" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'change'}">
            <el-select v-model="user.school" @change="selectSchool" @visible-change="getSchools" :placeholder="$t('SELECTSCHOOL')">
              <el-option
                v-if="key.split('_')[1] !== undefined"
                :key="key"
                v-for="(label, key) in schools"
                :label="label.Name"
                :value="key">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item :label="$t('USERNAME')" prop="username" :rules="[{required: true, message:$t('ISREQUIRED'), trigger:'blur'},{type:'email', message:$t('MUSTCONTAINAVALIDEMAILADDRESS'), trigger:'blur,change'}]">
              <el-input size="large" class="form-control" @keyup.native.enter="auth()" v-model="user.username" :autofocus="true"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="$t('PASSWORD')" prop="password" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'blur,change'}">
              <el-input type="password" size="large" class="form-control" @keyup.native.enter="auth()" v-model="user.password"></el-input>
          </el-form-item>
        </el-row>
    </el-form>

    <div class="form-footer">
      <div class="curve-down-area"></div>
      <div class="down-curve down-curve2"></div>
      <div class="login-page-container">
          <div class="form-signin">
              <el-row class="submit_button">
            <el-button :disabled="validateInput()"  @click="auth" size="large" class="btn-lg"  style="margin-bottom:10px; width:480px" v-text="loading ? $t('AUTHENTICATING') : $t('LOGIN')"></el-button>
              </el-row>
              <el-button type="text" @click="passwordReset" style="color:#4B4B4B">{{$t('FORGOTPASSWORD')}}</el-button>
          </div>
      </div>
    </div>
    </div>
</template>

<script>

  import { EventBus } from '../event-bus.js'
  export default {
    data () {
      return {
        user: {username: null, password: null, school: 'default'},
        schools: [],
        sending: false,
        loading: false,
        lang: null,
        main_school: {},
        logo: null,
        loading_logo: true,
        is_center: false,
        show_dropdown: false
      }
    },
    computed: {
      referrer () {
        if (document.referrer !== undefined) return document.referrer
      }
    },
    mounted () {
      console.log('mounted in login..')
      if (!localStorage.getItem('lang')) localStorage.setItem('lang', 'en')
      this.getSchools()
      this.lang = localStorage.getItem('lang', 'en')
    },
    methods: {
      selectSchool (val) {
        if (!this.is_center) return
        this.schools = []
        window.location.pathname = val.split('_')[1]
      },
      getSchools () {
        let self = this
        if (localStorage.getItem('userData')) return self.$router.push('/')
        if (self.schools.length !== 0) return
        this.$http.get('/schools').then(function (response) {
          self.schools = response.data
          self.detectSubDomain()
        }).catch(function (response) {})
      },
      detectSubDomain () {
        let host = window.location.host
        let subDomain = host.split('.')[0]
        let school = null
        if (window.location.pathname !== '/') {
          school = subDomain + '_' + window.location.pathname.replace('/', '')
          this.is_center = true
        }
        for (let key in this.schools) {
          if (school === null) {
            if (this.schools[key].SubDomain === subDomain && key === subDomain) {
              this.main_school = this.schools[key]
              this.logo = this.AWS_ASSETS + this.main_school.SchoolID + '/logo.png'
              return (this.user.school = key)
            }
          } else {
            if (school === key) {
              this.main_school = this.schools[key]
              return (this.user.school = school)
            }
          }
        }
        this.show_dropdown = true
      },
      auth () {
        let self = this
        if (self.validateInput()) return
        self.loading = true
        this.$http.post('/auth', self.user).then(function (response) {
          let type = 'error'
          if (!response.data.error) {
            type = 'success'
            let userData = response.data.user_data
            let locale = {'country': userData.school_location.country, 'timeZone': 'N/A'}
            let lang = userData.lang
            localStorage.setItem('lang', lang)
            localStorage.setItem('locale', JSON.stringify(locale))
            EventBus.$emit('userData', userData)
            self.$router.push('/')
          }
          self.$message({message: self.$t(response.data.message), type: type, showClose: response.data.error})
          if (type === 'error') self.loading = false
        }).catch(function (response) {})
      },
      keyHandler (e) {
        console.log(e.key)
        if (e.key === 'Enter') {
          e.preventDefault()
        }
      },
      passwordReset () {
        this.$prompt(this.$t('PLEASEENTERYOUREMAILADDRESS'), this.$t('FORGOTPASSWORDT'), {
          confirmButtonText: this.$t('SUBMIT'),
          cancelButtonText: this.$t('CANCEL'),
          inputPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          inputErrorMessage: this.$t('INVALIDEMAILADDRESS'),
          beforeClose: (action, instance, done) => {
            if (action !== 'confirm') return done()

            let self = this
            instance.confirmButtonLoading = true
            instance.confirmButtonText = this.$t('SENDING')
            this.$http.post('/user/reset', {school: self.user.school, email: instance.inputValue})
            .then(function (response) {
              let type = 'success'
              if (response.data.error) {
                type = 'error'
                instance.confirmButtonLoading = false
                instance.confirmButtonText = self.$t('SUBMIT')
              }
              self.$message({
                type: type,
                message: self.$t(response.data.message)
              })
              if (!response.data.error) {
                instance.confirmButtonLoading = false
                done()
              }
            }).catch(function (response) {})
          }
        })
      },
      validateInput () {
        let regEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!this.user.username || !this.user.password) return true
        if (!regEmail.test(this.user.username)) return true
        return false
      },
      loadingLogo () {
        if (this.logo === null) return
        let image = new Image()
        let self = this
        image.onload = function () {
          self.loading_logo = false
        }
        image.onerror = function () {
          self.loading_logo = false
          throw new Error('logo not found')
        }
        return (image.src = this.logo)
      }
    }
  }
</script>
<style>

.form-signin .img{
    margin-top: 15px;
}
.form-signin form {
    max-width: 480px;
    margin: 0 auto;

}

.form-signin.content{ background-color: #f3f2ee}

.form-signin h2 {
    color: #4b4b4b;
    font-size: 30px;
    font-family: "MavenProLight3", Arial, sans-serif;
    line-height: 50px;
    margin: 13px 0 10px;

}
.form-footer {
    background-color: #f5c93c;
}

.login-page-container{min-height: 180px}
.down-curve2 {
    width: 100%;
}

.down-curve {
    background: #f3f2ee;
    height: 40px;
    margin: 0 auto;
    width: 25%;
}
/* line 153, ../scss/components/_general.scss */
.down-curve::before {
    content: "";
    background: #f5c93c;
    -webkit-border-top-right-radius: 30px;
    border-top-right-radius: 30px;
    float: left;
    height: 40px;
    width: 50%;
}
/* line 161, ../scss/components/_general.scss */
.down-curve::after {
    content: "";
    background: #f5c93c;
    -webkit-border-top-left-radius: 30px;
    border-top-left-radius: 30px;
    float: left;
    height: 40px;
    width: 50%;
}
/* line 160, ../scss/pages/web/_login.scss */
.down-curve2:before {
    border-top-left-radius: 0;
}
/* line 163, ../scss/pages/web/_login.scss */
.down-curve2:after {
    border-top-right-radius: 0;
}

/* line 167, ../scss/pages/web/_login.scss */
.curve-down-area {
    border-radius: 0 0 50px 50px;
    background-color: #f3f2ee;
    height: 40px;
}
.form-signin{text-align:center}
.form-signin .img{display: inline-block;;background-size: contain;position: static; background-color: #fff; background-position: center;max-width:200px;min-width: 200px;height:200px; border-radius: 50%; border:#f5c93c solid 10px}
.form-signin .img .el-loading-mask{border-radius: 50%;}
.form-signin #username .btn,.form-signin #password .btn, .form-signin #school .btn-circle{position: absolute; left:0; top:-2px; z-index:10;background-color:#f5c93c; border-color:#f5c93c; color:#fff}

.form-signin .form-control input{ text-align:center;    border-radius: 25px;background-color:#f3ecd3; border: 0;}
.form-signin .form-control:active input, .form-signin input.form-control:focus input {
  background-color: #b2e3c2;
}
.form-signin button{border-radius: 25px;}
 .el-select{ width:100%;}
.form-signin #school .el-input input{background-color:#f3ecd3; border: 0;border-radius: 25px; padding-top:20px; padding-bottom:20px;
-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
-webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
-o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;}
.form-signin #school .dropdown-menu{background-color:#f3ecd3}
.form-signin .form-group{margin:0}
.form-signin label {height: 42px;
font-size: 16px;
line-height: 18px;
color: #373737;
padding-top: 12px; font-weight:normal}

.btn-lg{border-color: #2d2d2d;color:#000; background: none;font-size: 25px;}

.btn-lg:hover{
    background: #4b4b4b;
     border-color: #4b4b4b;

color:#fff
}

.navbar-inverse .navbar-nav > .active > a{   border-bottom: 2px solid #f5c93c;background: none;}

.form-signin .form-control input {
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
}
</style>



// WEBPACK FOOTER //
// Login.vue?1e69d546